import { SpinnerService } from './../../../../../base/spinner/spinner.service';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {
  CreateParkingSubscriptionDTO,
  IParkingSubscriptionDTO,
  ParkingSubscriptionClient,
  ParkingSubscriptionDTO,
  UpdateParkingSubscriptionDTO,
} from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable()
export class SubscriptionDetailsService {
  public loadedSubscription: ParkingSubscriptionDTO;
  public isBusy = false;

  constructor(private parkingSubscriptionClient: ParkingSubscriptionClient,
              private toastService: ToastService,
              private spinnerService: SpinnerService) {
  }

  public reset(): void {
    this.isBusy = false;
  }

  public getSubscription(subscriptionId: number): Observable<ParkingSubscriptionDTO> {
    this.loadedSubscription = null;
    this.isBusy = true;
    this.spinnerService.showSpinner = true;
    return this.parkingSubscriptionClient.getParkingSubscription(subscriptionId)
      .pipe(
        tap((subscription: ParkingSubscriptionDTO) => {
          this.isBusy = false;
          this.spinnerService.showSpinner = false;
          this.loadedSubscription = subscription;
        }),
        catchError((error: any) => {
          this.isBusy = false;
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public isSubscriptionUsedInSessions(subscriptionId: number): Observable<boolean> {
    return this.parkingSubscriptionClient.isParkingSubscriptionUsedInSessions(subscriptionId);
  }

  public createParkingSubscription(createSubscription: CreateParkingSubscriptionDTO): Observable<ParkingSubscriptionDTO> {
    this.isBusy = true;
    this.spinnerService.showSpinner = true;
    return this.parkingSubscriptionClient.createParkingSubscription(createSubscription)
      .pipe(
        tap(() => {
          this.isBusy = false;
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess(
            'i18n.domain.administration.subscription-details.messages.create-title',
            'i18n.domain.administration.subscription-details.messages.create-success-message',
          );
        }),
        catchError((error: any) => {
          this.isBusy = false;
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
          }
          return throwError(() => error);
        }),
      );
  }

  public updateParkingSubscription(updateSubscription: UpdateParkingSubscriptionDTO): Observable<IParkingSubscriptionDTO> {
    this.isBusy = true;
    this.spinnerService.showSpinner = true;
    return this.parkingSubscriptionClient.updateParkingSubscription(updateSubscription)
      .pipe(
        tap(() => {
          this.isBusy = false;
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess(
            'i18n.domain.administration.subscription-details.messages.update-title',
            'i18n.domain.administration.subscription-details.messages.update-success-message',
          );
        }),
        catchError((error: any) => {
          this.isBusy = false;
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
          }
          return throwError(() => error);
        }),
      );
  }

  public deleteSubscription(subscriptionId: number) {
    this.isBusy = true;
    this.spinnerService.showSpinner = true;
    return this.parkingSubscriptionClient.deleteParkingSubscription(subscriptionId)
      .pipe(
        tap(() => {
          this.isBusy = false;
          this.spinnerService.showSpinner = false;
          this.toastService.showSuccess(
            'i18n.domain.administration.subscription-details.messages.delete-title',
            'i18n.domain.administration.subscription-details.messages.delete-success-message',
          );
        }),
        catchError((error: any) => {
          this.isBusy = false;
          this.spinnerService.showSpinner = false;
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}

